import React, {Component} from 'react';
import {Bar} from 'react-chartjs-2';
import {connect} from "react-redux";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import {ROLES, withRoles} from "../Permissions";
import {actions} from "../../actions";
import {withStyles} from "@material-ui/core/styles/index";


let average = (array) => array.reduce((a, b) => Number(a) + Number(b)) / array.length;

/* takes a string phrase and breaks it into separate phrases
   no bigger than 'maxwidth', breaks are made at complete words.*/

const styles = {
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        marginTop: 10,
        marginBottom: 10
    }
};


const truncateTitle = function(str) {
    if(str.length > 40) {
        return str.slice(0,37) + '...';
    } else {
        return str
    }
}

const formatLabel = function(str, maxwidth){
    var sections = [];
    var words = str.split(" ");
    var temp = "";

    words.forEach(function(item, index){
        if(temp.length > 0)
        {
            var concat = temp + ' ' + item;

            if(concat.length > maxwidth){
                sections.push(temp);
                temp = "";
            }
            else{
                if(index == (words.length-1))
                {
                    sections.push(concat);
                    return;
                }
                else{
                    temp = concat;
                    return;
                }
            }
        }

        if(index == (words.length-1))
        {
            sections.push(item);
            return;
        }

        if(item.length < maxwidth) {
            temp = item;
        }
        else {
            sections.push(item);
        }

    });

    return sections;
}

class CriterionScoreBarChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            colors: [],
            index: 0,
            options: {},
            criteria: '',
            indexes: []
        };
    };

    createData(index) {
        let labels = [];
        let datasets = [{
            data:[],
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(0,0,0,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(0,0,0,1)',
        }];
        let ratingTotals = [];

        let criterion = this.props.form.rubrics[index];

        criterion.ratings.map(function(rating) {
            ratingTotals.push({rating: rating, total: 0});
        })

        this.props.form.reviewers.map(function(reviewer) {
            reviewer.artifactScores.map(function(obj){
                let score = obj.rubricScores[index];
                if(score != null) {
                    if(score !== -1) {
                        var ratingObj = ratingTotals.filter(rating => {
                            return rating.rating.points === score
                        })

                        let newTotal = ratingObj[0].total + 1;
                        ratingObj[0].total = newTotal;
                    } else if(score === -1) {
                        var ratingObj = ratingTotals.filter(rating => {
                            return rating.rating.na == true
                        })
                        if(ratingObj&&ratingObj.length){
                            let newTotal = ratingObj[0].total + 1;
                            ratingObj[0].total = newTotal;
                        }
                    } else {

                    }
                } else {
                    //Not started
                }
            })
        })

        ratingTotals.map(function(rating) {
            let shortenedLabel = rating.rating.rating_title + ' ';
            if(!rating.rating.na) {
                shortenedLabel += rating.rating.points + 'pts';
            }
            shortenedLabel = formatLabel(shortenedLabel,10);
            labels.push(shortenedLabel);
            datasets[0].data.push(rating.total);
        })

        return {
            labels: labels,
            datasets: datasets
        }
    }

    componentDidMount() {
        this.setState({options: {
            responsive: false,
            legend: {
                display: false
            },
            tooltips: {
                enabled: false
            },
            scales: {
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Rating'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Number of scores received'
                    },
                    ticks: {
                        beginAtZero:true,
                        max: (this.props.form.numArtifacts * this.props.form.reviewers.length)
                    }
                }]
            }
        }});

        let index = 0;
        {_.map(this.props.form.rubrics, criteria => {
            let temp = this.state.indexes;
            temp.push({
                index: index,
                criteria_title: criteria.criteria_title
            });
            this.setState({
                indexes: temp
            });
            if(index == 0) {
                this.setState({criteria: criteria.criteria_title})
            }
            index++;
        })}

    }

    renderList() {
        return _.map(this.props.form.rubrics, option => {
            return (
                <MenuItem key={option.criteria_title} data-key={option.criteria_title} value={option.criteria_title} style={{width:'250'}}>
                    {option.criteria_title}
                </MenuItem>
            );
        });
    }

    handleChange = () => (event) => {
        this.setState({criteria: event.target.value});
        var result = this.state.indexes.find(obj => {
            return obj.criteria_title == event.target.value
        });
        this.setState({index: result.index});
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <form>
                    <TextField id="select-criteria" select label="Select Criteria" style={{width: '500px'}} value={this.state.criteria} onChange={this.handleChange()} margin="normal">
                        {this.renderList()}
                    </TextField>
                </form>
                <Grid item key={this.state.criteria}>
                    <Typography variant="h5" gutterBottom className={classes.headertitle}>
                        {truncateTitle(this.state.criteria)}
                    </Typography>
                    <Bar
                        data={this.createData(this.state.index)}
                        width={500}
                        height={500}
                        options={this.state.options}
                    />
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(CriterionScoreBarChart));

